<form class="m-1">
    <div class="row">

        <div class="col col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <div class="row">
                       
                        <div
                            class="col-xl-2 col-lg-2 col-md-2 select-container col-sm-2 mb-1 select-container">
                            <label>Garant :
                                
                            </label>
                            <input class="form-control custom-input" disabled
                                placeholder="Codification" autocomplete="off"
                                [(ngModel)]="itemProduitBareme.garant_libelle" name="garant_libelle" autocomplete="off"
                                type="text" />
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px;">
                            <label>Codification:
                                
                            </label>
                            <input class="form-control custom-input" disabled
                                placeholder="Codification" autocomplete="off"
                                [(ngModel)]="itemProduitBareme.codification" name="codification" autocomplete="off"
                                type="text" />
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label>Libellé :
                                
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Libellé"
                                autocomplete="off" [(ngModel)]="itemProduitBareme.libelle" name="libelle"
                                autocomplete="off" type="text" />
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                            <label>Mode reconduction :
                                
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Mode réconduction"
                                autocomplete="off" [(ngModel)]="itemProduitBareme.mode_reconduction_libelle" name="mode_reconduction_libelle"
                                autocomplete="off" type="text" />
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                            <label>Mode de tarification :
                                
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Mode tarification"
                                autocomplete="off" [(ngModel)]="itemProduitBareme.mode_tarification_libelle" name="mode_tarification_libelle"
                                autocomplete="off" type="text" />
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                            <label>Mode de fractionnement :
                                
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Mode fractionnement"
                            autocomplete="off" [(ngModel)]="itemProduitBareme.mode_fractionnement_libelle" name="mode_fractionnement_libelle"
                            autocomplete="off" type="text" />
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label>Taux de couverture:
                                
                            </label>
                            <br>
                            <input disabled class="form-control custom-input"
                                [(ngModel)]="itemProduitBareme.taux_couverture" name="taux_couverture"
                                autocomplete="off" type="text" mask="000" />
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label>Nombre pers. par famille:
                                
                            </label>
                            <br>
                            <input disabled class="form-control custom-input"
                                [(ngModel)]="itemProduitBareme.nombre_personnes_famille"
                                name="nombre_personnes_famille" autocomplete="off" type="text"
                                mask="separator" />
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label>Plafond annuel collège:
                                <!--  -->
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Plafond annuel collège"
                                autocomplete="off" [(ngModel)]="itemProduitBareme.plafond_annuel_college"
                                name="plafond_annuel_college" autocomplete="off" type="text"
                                mask="separator" />
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label>Plafond annuel famille:
                                <!--  -->
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Plafond annuel famille"
                                autocomplete="off" [(ngModel)]="itemProduitBareme.plafond_annuel_famille"
                                name="plafond_annuel_famille" autocomplete="off" type="text"
                                mask="separator" />
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label (click)="openModalPrestataireReseau()"
                                [ngClass]="{'isSelectedItem':itemProduitBareme.reseau_de_soin_id}">Réseau de soin :
                                
                            </label>

                            <input disabled class="form-control custom-input" placeholder="Réseau de soin"
                            autocomplete="off" [(ngModel)]="itemProduitBareme.reseau_de_soin_libelle" name="reseau_de_soin_libelle"
                            autocomplete="off" type="text" />

                        </div>

                        <div 
                            class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1"
                            style="padding-left: 5px; padding-right: 5px">
                            <label>Prime par famille:
                                <!--  -->
                            </label>
                            <input disabled class="form-control custom-input" placeholder="Prime par famille"
                                autocomplete="off" [(ngModel)]="itemProduitBareme.prime_par_famille"
                                name="prime_par_famille" autocomplete="off" type="text" mask="separator" />
                        </div>

                    </div>
                </div>
                <div class="col-md-2">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1"
                            style="padding-left: 5px; padding-right: 5px">

                            <input disabled [(ngModel)]="itemProduitBareme.is_couverture_hospitalisation"
                                id="is_couverture_hospitalisation" name="is_couverture_hospitalisation"
                                autocomplete="off" type="checkbox" />
                            <label for="is_couverture_hospitalisation">Couverture hospitalisation?
                            </label>
                            <br>
                            <input disabled id="is_couverture_consultation"
                                [(ngModel)]="itemProduitBareme.is_couverture_consultation"
                                name="is_couverture_consultation" autocomplete="off" type="checkbox" />
                            <label for="is_couverture_consultation">Couverture consultation?
                            </label>
                            <br>
                            <input disabled id="is_couverture_dentaire"
                                [(ngModel)]="itemProduitBareme.is_couverture_dentaire"
                                name="is_couverture_dentaire" autocomplete="off" type="checkbox" />
                            <label for="is_couverture_dentaire">Couverture dentaire?
                            </label>
                            <br>
                            <input disabled id="is_couverture_optique" [(ngModel)]="itemProduitBareme.is_couverture_optique"
                                name="is_couverture_optique" autocomplete="off" type="checkbox" />
                            <label for="is_couverture_optique">Couverture optique?
                            </label>

                        </div>
                    </div>

                </div>



            </div>

        
                        <div class="col col-md-12">
                            <div class="row">

                                
                                <div class="table-responsive">
                                    <table class="table table-condensed table-hover">
                                        <thead>
                                            <tr class="custom-table-head">
                                                <th style="width: 9%;">
                                                    <!-- <a style="cursor: pointer;margin-top: 5px;"
                                                        (click)="currentPage = 0; getItemsPrimeByProduit()"
                                                        title="Actualiser">
                                                        <i class="fa fa-redo-alt"></i></a> -->
                                                </th>
                                            <tr class="custom-table-head">

                                                <th>Statut</th>
                                                <th>Prime</th>
                                                <th>Plafond</th>
                                                <th>Age min</th>
                                                <th>Age max</th>
                                                <th>Nombre autorisé</th>
                                                <th>Nombre suppl. autorisé</th>
                                                <th>Surprime</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="cursor: pointer;"
                                                *ngFor="let item of itemsStatutInitialized; let indice = index">
                                                <td style="font-weight: 700;">{{item.libelle}}</td>
                                                <td >
                                                    <input disabled class="form-control custom-input"
                                                        autocomplete="off" [(ngModel)]="item.prime"
                                                         autocomplete="off" type="text"
                                                         
                                                        mask="separator" [ngModelOptions]="{standalone: true}" />
                                                </td>
                                                <td>
                                                    <input disabled class="form-control custom-input"
                                                        [(ngModel)]="item.plafond"  
                                                        autocomplete="off" type="text" mask="separator" [ngModelOptions]="{standalone: true}" />
                                                </td>
                                                <td>
                                                    <input disabled class="form-control custom-input"
                                                        [(ngModel)]="item.age_min"  
                                                        autocomplete="off" type="text" mask="separator" [ngModelOptions]="{standalone: true}" />
                                                </td>

                                                <td><input disabled class="form-control custom-input"
                                                        [(ngModel)]="item.age_max" 
                                                        autocomplete="off" type="text" mask="separator" [ngModelOptions]="{standalone: true}" />
                                                </td>
                                                <td ><input disabled disabled  class="form-control custom-input"
                                                        [(ngModel)]="item.nombre_autorise"
                                                         autocomplete="off" 
                                                        type="text" mask="separator" [ngModelOptions]="{standalone: true}" /></td>
                                                
                                                        <td><input  disabled [class.isNotConsidered]="item.nombre_autorise == 0"  class="form-control custom-input"
                                                            [(ngModel)]="item.nombre_supplementaire_autorise"
                                                            
                                                            autocomplete="off" type="text" mask="separator" [ngModelOptions]="{standalone: true}" />
                                                    </td>
                                                    <td>
                                                        <input  disabled [class.isNotConsidered]="item.nombre_autorise == 0"  class="form-control custom-input"
                                                            [(ngModel)]="item.surprime_si_supplementaire"
                                                             autocomplete="off"
                                                            type="text" mask="separator" [ngModelOptions]="{standalone: true}" />
                                                    </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1"
            style="padding-left: 5px; padding-right: 5px">
            <label>Description:
                
            </label>
            <textarea disabled class="form-control custom-input" [(ngModel)]="itemProduitBareme.description"
                name="description" placeholder="Description" id="" cols="30" rows="3"></textarea>
        </div>
</form>